import { useFeatureFlags } from "./use-feature-flags";

export const KUALOA_BRAND_NAME = "The Kualoa Beach House";
export const PORTFOLIO_BRAND_NAME = "Vacation Rental Oahu";

/**
 * The brand the site speaks as. One home published: the Kualoa house. More
 * than one: Vacation Rental Oahu. Every mark, name and default line that is
 * not about one specific home should read from here.
 */
export function useSiteBrand() {
  const flags = useFeatureFlags();
  const portfolio = flags.portfolioHomepage && flags.publishedHomeCount > 1;
  return {
    portfolio,
    name: portfolio ? PORTFOLIO_BRAND_NAME : KUALOA_BRAND_NAME,
    lockup: (portfolio ? "portfolio" : "kualoa") as "portfolio" | "kualoa",
  };
}
